import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Box, Button, TableCell, Typography } from "@mui/material";
import React from "react";

import MaterialAPI from "../api/Material.api";
import BasicCreateModal from "../components/BasicCreateModal";
import Layout from "../components/Layout";
import ListModel from "../components/ListModel";
import { Material, TableColumn } from "../types";
import { extractDate } from "../utils";

const columns: TableColumn<Material>[] = [
  { field: "name", label: "Name" },
  { field: "createdAt", label: "Created At Date" },
];

function buildTableRow(material: Material): JSX.Element[] {
  return [
    <TableCell key={"name"}>{material.name}</TableCell>,
    <TableCell key={"createdAt"}>{extractDate(material.createdAt)}</TableCell>,
  ];
}

export default function MaterialList() {
  const [openModel, setOpenModal] = React.useState<boolean>(false);
  return (
    <Layout>
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h2">Materials</Typography>
          <Button onClick={() => setOpenModal(true)}>
            <AddCircleIcon />
          </Button>
        </Box>

        <ListModel
          defaultOrderBy={"name"}
          modelApiUseList={MaterialAPI.useList}
          modelBaseUrl={"materials"}
          columns={columns}
          buildTableRow={buildTableRow}
        />
        <BasicCreateModal
          open={openModel}
          onClose={() => setOpenModal(false)}
          modelApiUseSave={MaterialAPI.useSave}
          navigateUrl="/materials"
        />
      </Box>
    </Layout>
  );
}
